import { contentApi } from "@/api/content-api";
import Noice from "@/pages/homecenter/components/noice";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { Layout } from "../../components/layout";
import { MobileHeader } from "../../components/mobile-header/mobile-header";
import { ActionsList } from "./actions-list";
import { HeroSection } from "./hero-section";
import { HistoryData } from "./history-data";
import { LockUp } from "./lock-up";
import { MarketSection } from "./market-section";
import StartRiver from "./start-river";
import { SwiperSection } from "./swiper-section";
import { TopScroll } from "./top-scroll";

export function HomePage() {
  const [content, setContent] = useState({});
  const loadContentList = async () => {
    try {
      const data = await contentApi.list({ pageNum: 1, pageSize: 1 });
      if (data?.ok && data?.data?.records) {
        const records = data.data.records;
        if (Array.isArray(records) && records.length > 0) {
          setContent(records[0] || {});
        }
      }
    } catch (error) {
      console.error("Failed to load content:", error);
    }
  };

  useEffect(() => {
    loadContentList();
  }, []);

  return (
    <Layout>
      {isMobile && <MobileHeader />}
      <TopScroll />
      <HeroSection />
      <HistoryData />
      <div className="container mx-auto px-20">
        <Noice content={content} />
      </div>
      <SwiperSection />
      <LockUp />
      <MarketSection />
      <ActionsList />
      <StartRiver />
    </Layout>
  );
}
